import { render, staticRenderFns } from "./UserRoleModal.vue?vue&type=template&id=f27b1d7c&scoped=true&"
import script from "./UserRoleModal.vue?vue&type=script&lang=js&"
export * from "./UserRoleModal.vue?vue&type=script&lang=js&"
import style0 from "./UserRoleModal.vue?vue&type=style&index=0&id=f27b1d7c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f27b1d7c",
  null
  
)

export default component.exports